<template>
  <div class="estado_box">
    <h3>{{ $t("procedimento.UMA_LANG_DOCSBOLSA_ESTADO_ACTUAL") }}:</h3>
    <h4>{{ item.docprocedconcursal_estado.label }}</h4>
  </div>
  <template v-if="item.docprocedconcursal_unidadeorganica.ID > 0">
    <h5>{{ $t("procedimento.UMA_LANG_DOCSBOLSA_UNIDADE") }}:</h5>
    <p>{{ item.docprocedconcursal_unidadeorganica.post_title }}</p>
  </template>
  <template v-if="item.docprocedconcursal_categoria_profissional != null">
    <h5>{{ $t("procedimento.UMA_LANG_DOCSBOLSA_CATEGORIAPROF") }}:</h5>
    <p>{{ item.docprocedconcursal_categoria_profissional.label }}</p>
  </template>
  <template v-if="item.docprocedconcursal_nvagas != ''">
    <h5>{{ $t("procedimento.UMA_LANG_DOCSBOLSA_N_VAGAS") }}:</h5>
    <p>
      {{ item.docprocedconcursal_nvagas }}
      {{ $t("procedimento.UMA_LANG_DOCSBOLSA_VAGA_DISPONIVEL") }}
    </p>
  </template>
  <template v-if="item.docprocedconcursal_datafim != ''">
    <h5>{{ $t("procedimento.UMA_LANG_DOCSBOLSA_CANDIDATURASATE") }}:</h5>
    <p>{{ dataFim }}</p>
  </template>
  <template v-if="item.docprocedconcursal_dataatribuicao != ''">
    <h5>{{ $t("procedimento.UMA_LANG_DOCSBOLSA_DATACONCLUSAO") }}:</h5>
    <p>{{ dataAtribuicao }}</p>
  </template>
</template>

<script>
import { computed } from "vue";

export default {
  props: ["item","estado","unidade","categoria","vagas","datafim","dataatr"],
  setup(props) {

    const dataAtribuicao = computed(() => {
      const [year, month, day] = props.item.docprocedconcursal_dataatribuicao.split('-');
      return `${day}/${month}/${year}`;
    })

    const dataFim = computed(() => {
      const [year, month, day] = props.item.docprocedconcursal_datafim.split('-');
      return `${day}/${month}/${year}`;
    })

    return {
      dataFim,
      dataAtribuicao
    }
  }
}
</script>

<style lang="scss" scoped>
.estado_box {
  background-color: #6eb7ec;
  padding-bottom: 30px;
  margin-bottom: 91px;
}

@media screen and (max-width:1024px) {
  .estado_box{display: none;}
}

.estado_box h3 {
  font-size: 12px;
  font-family: "Montserrat Bold";
  text-transform: uppercase;
  color: white;
  margin-bottom: 0px;
  padding: 25px;
  padding-bottom: 10px;

}

.estado_box h4 {
  font-family: "Montserrat Bold";
  font-size: 20px;
  color: white;
  padding-left: 25px;
  padding-right: 25px;
}

.bolsa_detalhe h5 {
  font-size: 12px;
  font-family: "Montserrat Semibold";
  text-transform: uppercase;
  color: #535d61;
  margin-bottom: 0px;
}

.bolsa_detalhe h1 {
  font-family: "Montserrat Bold";
  font-size: 24px;
  padding-bottom: 10px;
  margin-top: 50px;
  color: #535d61;
}

.bolsa_detalhe h2 {
  color: #6eb7ec;
  font-family: "Montserrat Bold";
  font-size: 20px;
  padding-bottom: 28px;
}

.bolsa_detalhe p {
  font-family: "Montserrat";
  font-size: 16px;
  margin-bottom: 30px;
  margin-top: 5px;
  font-family: 'PT Sans';
  color: #656565;
}

@media (min-width : 768px) and (max-width : 1024px) {
  .bolsa_detalhe>.row:first-of-type .columns:first-of-type {
    padding-right: 0px;
    padding-left: 0px;
  }

  .bolsa_detalhe h1 {
    font-size: 20px;
    margin-top: 35px;
  }

  .bolsa_detalhe h2 {
    font-size: 18px;
  }

  .bolsa_detalhe p {
    font-size: 15px;
    margin-bottom: 20px;
  }

}

@media screen and (max-width:767px) {
  .bolsa_detalhe h1 {
    font-size: 16px;
    margin-top: 10px;
    padding-top: 15px;
    margin-bottom: 0px;
    padding-bottom: 5px;
  }

  .bolsa_detalhe h2 {
    font-size: 16px;
    padding-top: 5px;
    padding-bottom: 20px;
  }

  .servico_bolsas_detalhe h5 {
    font-size: 12px;
  }

  .servico_bolsas_detalhe p {
    font-size: 14px;
    margin-bottom: 20px;
  }
}
</style>